import { FormikErrors } from "formik";
import { NotificationFormValues } from "./types";
import DateUtil from "../../util/DateUtil";
import { CherryPayApi } from "../../api/models";
import { isEmptyStr } from "../../util/StringUtil";

export const validateNotificationForm = (
  values: NotificationFormValues,
  timezones?: CherryPayApi.EnumConfigurationItem[]
): FormikErrors<NotificationFormValues> => {
  const errors: FormikErrors<NotificationFormValues> = {};

  const locationOverrideCount = Object.values(
    values.locationMessageOverrides ?? {}
  ).filter((v) => !isEmptyStr(v)).length;

  if (locationOverrideCount > 0 && !values.endDateTime) {
    errors.endDateTime =
      "End date is required when location messages are overridden";
  }

  if (
    values.endDateTime &&
    values.sendDateTime &&
    values.endDateTime.getTime() <= values.sendDateTime.getTime()
  ) {
    errors.endDateTime = "End date/time must be after the send date/time.";
  }

  if (values.displayName && values.displayName.length > 150) {
    errors.displayName = "Campaign Name must be less than 150 characters";
  }

  if (values.passUpdateMessage && values.passUpdateMessage.length > 150) {
    errors.passUpdateMessage =
      "Notification Message must be less than 150 characters";
  }

  if (
    values.stopSendingOption === "specific" &&
    values.stopSendingTimeUnit === "custom"
  ) {
    if (
      values.stopSendingCustomUnit === "minutes" &&
      (values.stopSendingCustomValue < 1 || values.stopSendingCustomValue > 60)
    ) {
      errors.stopSendingOption = "Minutes must be between 1 and 60";
    }

    if (
      values.stopSendingCustomUnit === "hours" &&
      (values.stopSendingCustomValue < 1 || values.stopSendingCustomValue > 24)
    ) {
      errors.stopSendingOption = "Hours must be between 1 and 24";
    }
  }

  // Validate sendDateTime against "now" in the selected Windows timezone.
  // Use the timezone Key (Windows id) so DST is applied via IANA mapping —
  // the display Value's fixed "(UTC±HH:MM)" prefix is wrong during DST.
  if (values.sendDateTime && timezones) {
    const selectedTimezoneKey = timezones.find(
      (tz) => tz.Key === values.timeZoneId
    )?.Key;

    if (!selectedTimezoneKey) {
      errors.timeZoneId = "A valid timezone must be selected.";
    } else {
      const currentDateTimeInTimezone =
        DateUtil.getLocalDateTimeInUTCFormatFromDateObject(
          DateUtil.getGivenDateTimeInTimezone(selectedTimezoneKey, new Date())
        );
      const selectedDateTimeInTimezone =
        DateUtil.getLocalDateTimeInUTCFormatFromDateObject(values.sendDateTime);
      const valid = DateUtil.validateTimeDifference(
        currentDateTimeInTimezone,
        selectedDateTimeInTimezone,
        1
      );

      if (!valid) {
        errors.sendDateTime =
          "Send date/time must be at least 1 hour in the future.";
        errors.timeZoneId =
          "Send date/time must be at least 1 hour in the future.";
      }
    }
  }

  return errors;
};
